export const ADMINS = 'ADMINS';
export const CREATE_ADMIN = 'CREATE_ADMIN';
export const DELETE_ADMIN = 'DELETE_ADMIN';
export const UPDATE_ADMIN = 'UPDATE_ADMIN';
export const SHOW_ADMIN = 'SHOW_ADMIN';
export const SEARCH_ADMINS = 'SEARCH_ADMINS';



// WEBPACK FOOTER //
// ./src/actions/admins/actionTypes.js